const DEFAULT_IMAGE_BASE_PATH = 'static';

export function getImagePath(imagePath: string, basePath = DEFAULT_IMAGE_BASE_PATH): string {
  if (!imagePath) {
    return '';
  }

  return `/${basePath}/${imagePath}`;
}
